"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyIronPeakExists() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="py-8 sm:py-8 lg:py-8 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div ref={titleRef} className={`transition-all duration-700 ease-out ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-center text-foreground mb-8 lg:mb-12">
            Why IronPeak Exists
          </h2>
        </div>

        <div ref={contentRef} className={`transition-all duration-700 ease-out delay-150 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="prose prose-lg max-w-none">
            <p className="text-foreground/90 text-base sm:text-lg leading-relaxed mb-6 text-left">
              Too many men are placed on generic protocols without a proper medical evaluation—or told their symptoms are "normal aging."
            </p>

            <p className="text-foreground/90 text-base sm:text-lg leading-relaxed mb-6 text-left font-semibold">
              We believe men deserve better.
            </p>

            <p className="text-foreground/90 text-base sm:text-lg leading-relaxed mb-4 text-left">
              IronPeak was built to offer:
            </p>

            <ul className="space-y-4 text-foreground/90 text-base sm:text-lg text-left list-none pl-0 mb-6">
              <li className="flex items-start gap-3">
                
                <span className="leading-relaxed">
                  Real physician oversight
                </span>
              </li>
              <li className="flex items-start gap-3">
                
                <span className="leading-relaxed">
                  Thoughtful use of labs and diagnostics
                </span>
              </li>
              <li className="flex items-start gap-3">
                
                <span className="leading-relaxed">
                  Treatment plans that respect physiology and long-term health
                </span>
              </li>
              <li className="flex items-start gap-3">
                
                <span className="leading-relaxed">
                  Ongoing follow‑up and optimization—not one‑time prescriptions
                </span>
              </li>
            </ul>

            <p className="text-foreground/90 text-base sm:text-lg leading-relaxed mb-2 text-left">
              Our goal is not to sell medication.
            </p>

            <p className="text-foreground/90 text-base sm:text-lg leading-relaxed text-left">
              Our goal is to help men feel strong, sharp, and capable again.
            </p>
          </div>
        </div>
      </div>
    </section>;
}